export default __webpack_public_path__ + "static/media/screen5.5f43b237.png";